<template>
  <wh-popup
    v-model="myVisible"
    :ref-form="$refs.LogisticsPopup"
    :title="title"
    @close="hidePopup"
    @open="open"
  >
    <van-form
      ref="LogisticsPopup"
      class="logistics-popup"
      label-width="60px"
      @submit="submitForm"
    >
      <div class="main">
        <van-field
          :value="form.operatingTime"
          clickable
          label="操作时间"
          name="datetimePicker"
          placeholder="点击选择时间"
          @click="showPickerDate = true"
        >
          <template #right-icon>
            <span class="checkList">选择</span>
          </template>
        </van-field>
        <wh-staff
          v-model="form.staffName"
          :rules="[{required:true,message: '请选择操作人'}]"
          lable="操作人"
          name="操作人"
          style="padding:0;"
        />
        <van-field
          v-model="form.receiver"
          :rules="[{required:true,message: '请输入收件人'}]"
          label="收件人"
          name="收件人"
          placeholder="请输入收件人"
        />
        <van-field
          v-model="form.contactPhone"
          :rules="[{required:true,message: '请输入联系方式'}]"
          label="联系方式"
          name="联系方式"
          placeholder="请输入联系方式"
        />
        <van-field
          v-model="form.receiptAddress"
          :rules="[{required:true,message: '请输入收货地址'}]"
          label="收货地址"
          name="收货地址"
          placeholder="请输入收货地址"
        />
        <wh-popup-select
          v-model="form.packingId"
          :columns="goodsList"
          :disabled="disabled"
          :rules="[{validator,message: '请选择库存商品'}]"
          label="库存商品"
          name="库存商品"
          placeholder="请选择库存商品"
          style="background:#fff"
          @itemChange="getProductList"
        >
          <template slot="right-icon">
            <span class="checkList">选择</span>
          </template>
        </wh-popup-select>
        <div v-for="(i,key) in form.goods||[]" :key="key">
          <div class="raw-list wh-flex-between">
            <div class="material-name van-ellipsis">
              {{ i.productName }}
            </div>
            <div>库存：{{ i.allQuantity }}</div>
            <div class="wh-flex-start count" style="width: 100px">
              <span>用量：</span>
              <van-field
                v-model.number="i.quantity"
                :disabled="i.flag||disabled"
                class="quantity"
                input-align="center"
                type="number"
              />
              <span>
                {{ i.unit }}
              </span>
            </div>
            <div>
              <van-icon v-if="!i.flag" color="#20CAA0" name="checked" size="20" @click="subRaw(i)" />
              <svg-icon
                v-else
                v-show="!disabled"
                icon-class="edit"
                style="width:20px;height:20px"
                @click.native="i.flag = !i.flag"
              />
              <van-icon v-show="!disabled" color="#FF4444" name="delete" size="20" @click="delRaw(i,key)" />
            </div>
          </div>
        </div>
        <van-field v-model="form.remarks" label="备注" placeholder="请输入备注" />
        <div class="wh-flex-start" style="padding:10px 16px;background:#fff;align-items: flex-start">
          <div style="margin-right: 10px">
            图片
          </div>
          <wh-upload v-model="form.photo" :files-str.sync="photoStr" :max-count="1" />
        </div>
      </div>
      <van-popup v-model="showPickerDate" position="bottom">
        <van-datetime-picker type="datetime" @cancel="showPicker = false" @confirm="onConfirm" />
      </van-popup>
    </van-form>
  </wh-popup>
</template>
<script>
import api from '@/api'
import { formatTime } from '@/utils/convert/convertTime'
import WhPopup from '@/components/public/WhPopup/WhPopup.vue'
import WhUpload from '@/components/public/WhUpload/WhUpload'
import { formPopup } from '@/utils/mixins/formPopup'
import WhStaff from '@/components/public/WhStaff/WhStaff'
import WhPopupSelect from '@/components/public/WhPopupSelect/WhPopupSelect'
import { Dialog } from 'vant'

export default {
  name: 'LogisticsPopup',
  components: { WhPopup, WhStaff, WhPopupSelect, WhUpload },
  mixins: [formPopup],
  data() {
    return {
      showPickerDate: false,
      form: {
        id: undefined,
        operatingTime: this.formatTime(new Date(), 'YYYY-MM-DD HH:mm:00'),
        staffName: '',
        receiver: '',
        contactPhone: '',
        receiptAddress: '',
        packingId: '',
        remarks: '',
        photo: [],
        goods: []
      },
      photoStr: '',
      goodsList: [{
        text: '包装',
        children: []
      }, {
        text: '半成品',
        children: []
      }]
    }
  },
  computed: {
    title() {
      return this.formType === 'create' ? '新增物流' : '编辑物流'
    },
    disabled() {
      return this.title === '编辑物流'
    }
  },
  watch: {
    visible: {
      handler(newV) {
        this.$nextTick(() => {
          this.$refs.LogisticsPopup.resetValidation()
        })
      }
    }
  },
  methods: {
    formatTime,
    async getGoodsList() {
      this.goodsList = [{
        text: '包装',
        children: []
      }, {
        text: '半成品',
        children: []
      }]
      // 包装
      await api.getPackingManagementJL().then(res => {
        res.data.list.map(i => {
          this.goodsList[0].children.push({
            ...i,
            text: i.productName + ':' + i.packingQuantity + i.specificationPacking,
            value: i.id,
            type: '包装'
          })
        })
      })
      // 半成品
      await api.getParPreparedProductsList().then(res => {
        res.data.list.map(i => {
          this.goodsList[1].children.push({
            ...i,
            text: i.name + ':' + i.quantity + i.unit,
            value: i.id,
            type: '半成品'
          })
        })
      })
    },
    getProductList(arr) {
      let item = {}
      const index = Number(arr[0] === '半成品')
      item = this.goodsList[index].children.find(i => i.text === arr[1])
      this.form.packingId = ''
      this.addGoods(item, arr[0])
    },
    validator(val) {
      return Boolean(this.form.goods.length)
    },
    addGoods(data, u) {
      if (!data.packingQuantity && !data.quantity) {
        this.$toast.fail('该产品无库存,请重新选择')
        return
      }
      const index = this.form.goods.findIndex(i => i.id === data.id && i.type === u)
      if (index < 0) {
        this.form.goods.push({
          productName: data.productName || data.name, // 产品名称
          id: data.id, // 产品id
          unit: data.specificationPacking || data.unit, // 单位
          allQuantity: data.packingQuantity || data.quantity, // 库存数量
          quantity: 0,
          flag: false,
          type: u
        })
      } else {
        this.$toast.fail('已选择该产品')
      }
    },
    onConfirm(date) {
      this.form.operatingTime = formatTime(date, 'YYYY-MM-DD HH:mm:00')
      this.showPickerDate = false
    },
    open() {
      this.getGoodsList()
      if (this.formType === 'create') {
        this.formDataInit(this.form, {
          operatingTime: this.formatTime(new Date(), 'YYYY-MM-DD HH:mm:00')
        })
      } else {
        this.initFormData.operatingTime = formatTime(this.initFormData.operatingTime, 'YYYY-MM-DD HH:mm:00')
        this.formDataInit(this.form, this.initFormData)
      }
    },
    // 编辑
    subRaw(i) {
      if (i.quantity > i.allQuantity || !i.quantity) {
        this.$toast.fail('输入数量超过库存或者为0')
      } else {
        i.flag = true
      }
    },
    // 删除库存商品
    delRaw(row, index) {
      this.$dialog.confirm({
        message: '确认删除?'
      }).then(() => {
        if (row.id) {
          this.form.goods.splice(index, 1)
          return
        }
        if (row.deleted === 0) {
          row.deleted = 1
        }
      }).catch(() => {
      })
    },
    submitForm() {
      const save = this.form.goods.some(i => !i.flag)
      const param = {
        ...this.form,
        photo: this.photoStr
      }
      const apiName = this.form.id ? 'updateLogisticsManagementJL' : 'createLogisticsManagementJL'
      if (save) {
        this.$toast.fail('请保存库存商品用量')
        return
      }
      if (!this.disabled) {
        Dialog.confirm({
          title: '提示',
          message: '提交后无法修改，请确认库存商品信息是否填写正确'
        }).then(() => {
          api[apiName](param).then(res => {
            this.hidePopup()
            this.submitFormSuccess()
          })
        }).catch(() => {
          // on cancel
        })
      } else {
        api[apiName](param).then(res => {
          this.hidePopup()
          this.submitFormSuccess()
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.logistics-popup {
  min-height: calc(100% - 90px);
  background-color: #F6F5F5;
  .checkList {
    width: 35px;
    font-size: 14px;
    color: #20CAA0;
  }
  .main {
    padding: 6px 0;
  }
}
.raw-list {
  padding: 5px 16px;
  margin-bottom: 2px;
  font-size: 12px;
  background-color: rgba(32, 202, 160, 0.12);
  word-break: keep-all;
  .material-name {
    width: 100px;
    &::before {
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background-color: #20CAA0;
      margin-right: 6px;
      margin-bottom: 2px;
    }
  }
  .quantity {
    width: 60px;
    font-size: 12px;
    padding: 0;
    background-color: #fff;
  }
}
</style>
